module.exports = __webpack_public_path__ + "img/bg.689006f2.png";